export const toRelationshipCompanyInitialValues = (company = {}) => ({
	name: company?.name ?? '',
	tradingName: company?.tradingName ?? '',
	website: company?.website ?? '',
	phone: company?.phone ?? '',
	email: company?.email ?? '',
	address: company?.address ?? '',
	city: company?.city ?? '',
	state: company?.state ?? '',
	postcode: company?.postcode ?? '',
	country: company?.country ?? '',
	abn: company?.abn ?? '',
	industry: company?.industry ?? '',
	ownerDocId: company?.ownerDocId ?? null,
});

export const companyProfileProperties = (values) => ({
	name: values.name?.trim(),
	tradingName: values.tradingName?.trim(),
	website: values.website?.trim(),
	phone: values.phone?.trim(),
	email: values.email?.trim(),
	address: values.address?.trim(),
	city: values.city?.trim(),
	state: values.state?.trim(),
	postcode: values.postcode?.trim(),
	country: values.country?.trim(),
	abn: values.abn?.trim(),
	industry: values.industry?.trim(),
	ownerDocId: values.ownerDocId,
});
